import type { ProgressPhotoDto } from '../api/generated/types.gen';

/**
 * Label for the weigh-in logged on a progress photo's date, e.g. "81.5 ק״ג" / "176.5 lbs".
 * The server already converts to the trainee's unit and only sends a weight for an exact-date
 * weigh-in, so a null here means "no weigh-in that day" — render nothing, never a fallback.
 */
export const formatPhotoWeight = (
    photo: Pick<ProgressPhotoDto, 'weight' | 'weightUnit'> | null | undefined
): string | null => {
    const weight = photo?.weight;
    if (weight === null || weight === undefined || !Number.isFinite(weight)) return null;
    const unit = photo?.weightUnit === 'LBS' ? 'lbs' : 'ק״ג';
    return `${Number(weight.toFixed(1))} ${unit}`;
};
